import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-6 col-md-12 col-12" }
const _hoisted_3 = { class: "col-lg-6 col-md-12 col-12" }
const _hoisted_4 = { class: "d-flex justify-content-center w-100 mt-3" }

import {ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import courseAssistedLivingCoachingService from "@/api/Course/AssistedLivingCoaching";
import Datepicker from "@/components/picker/Datepicker.vue";
import BaseNumber from "@/components/base/BaseNumber.vue";
import {requiredRule} from "@/shared/validators/validationRules";
import useVuelidate from "@vuelidate/core";
import SaveButton from "@/components/button/SaveButton.vue";

interface PriceFormData {
  startFrom: string;
  price: number | null;
}

interface Props {
  priceId: number;
  submitForm: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceForm',
  props: {
    priceId: {},
    submitForm: { type: Boolean }
  },
  emits: ["update:modelValue", "update:submitForm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const {t} = useI18n();
const isLoaded = ref(false);
const isSubmitting = ref(false);

const formData = ref<PriceFormData>({
  startFrom: '',
  price: null
});

const formRules = ref({
  startFrom: requiredRule(t),
  price: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.priceId) {
      await courseAssistedLivingCoachingService.putPrice(formData.value, +props.priceId);
    } else {
      await courseAssistedLivingCoachingService.postPrice(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPriceData(priceId: number) {
  try {
    const {data} = await courseAssistedLivingCoachingService.getPrice(+priceId);
    formData.value = {
      startFrom: data.data.startFrom,
      price: data.data.price,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.priceId) {
    await getPriceData(props.priceId);
  }

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Datepicker, {
              modelValue: formData.value.startFrom,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.startFrom) = $event)),
              required: true,
              label: _ctx.$t('general.start_from'),
              position: "down",
              validation: _unref(v$).startFrom,
              messages: _unref(v$).startFrom.required.$message
            }, null, 8, ["modelValue", "label", "validation", "messages"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BaseNumber, {
              modelValue: formData.value.price,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.price) = $event)),
              label: _ctx.$t('general.price'),
              required: true,
              min: -1000000,
              decimalPlaces: 2,
              validation: _unref(v$).price,
              messages: _unref(v$).price.required.$message
            }, null, 8, ["modelValue", "label", "validation", "messages"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SaveButton, {
            label: _ctx.$t('general.button.save'),
            loading: isSubmitting.value
          }, null, 8, ["label", "loading"])
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})